import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=1a491acd&scoped=true"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"
import style1 from "./Email.vue?vue&type=style&index=1&id=1a491acd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a491acd",
  null
  
)

export default component.exports